import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'

/* eslint-disable @typescript-eslint/no-var-requires */
const Layout = () => import('@/components/Layout/src/Layout.vue')

export const constantRoutes: AppRouteRecordRaw[] = [
  {
    name: 'Login',
    path: '/login',
    meta: {
      hidden: true,
      noCache: true
    },
    component: () => import('@/views/Login/Index.vue')
  },
  {
    path: '/404',
    name: '404Page',
    component: () => import('@/views/Error/404.vue'),
    meta: {
      title: '404',
      hidden: true,
      noCache: true
    }
  }
]
export const rootRoute = {
  path: '/',
  component: Layout,
  redirect: '/',
  name: 'Root',
  meta: {
    hidden: true
  }
}

export const noPermissionRoute = {
  path: '/no-permission',
  component: Layout,
  name: '',
  redirect: '/no-permission/index',
  children: [
    {
      path: 'index',
      name: 'noPermission',
      component: () => import('@/views/NoPermission/Index.vue'),
      meta: {
        title: '暂无权限'
      }
    }
  ],
  meta: {
    hidden: true,
    title: '暂无权限',
    noTagsView: true
  }
}

/**
 * 菜单重构--新菜单
 * @param  type : 'group', 'page' group是含子路由
 * @param  path :  路由路径
 * @param  name: 组件名称,用以收集keepalive组件
 * @param  component: 组件文件路径
 * @param  title 导航栏展示字段
 * @param  icon 导航栏 icon
 * @param  keepAlive : boolean  默认不写（false不需要缓存）
 * @param  isHiden : boolean  默认不写 （false 需要展示）
 * @param  activeMenu : string  用以高亮导航栏，一般写上一级
 */
// 前端预设菜单
export const presetRoutes: AppRouteRecordRaw[] = [
  {
    type: 'group',
    path: '/deliveryManagement',
    name: 'DeliveryManagement',
    redirect: '/deliveryManagement/promotion-link',
    component: Layout,
    meta: {
      title: '投放管理',
      icon: 'Link'
    },
    children: [
      {
        type: 'page',
        path: 'promotion-link',
        name: 'promotion-link',
        component: () => import('@/views/DeliveryManagement/PromotionLink/PromotionLink.vue'),
        meta: {
          title: '投放链接管理',
          icon: ''
        }
      },
      {
        type: 'page',
        path: 'report',
        name: 'report',
        component: () => import('@/views/DeliveryManagement/Report/Index.vue'),
        meta: {
          title: '回传管理',
          icon: ''
        },
        children: []
      },
      {
        type: 'detail',
        path: '/strategyDetail',
        component: () => import('@/views/DeliveryManagement/Report/components/StrategyDetail.vue'),
        name: 'strategyDetail',
        meta: {
          title: '回传策略详情',
          icon: '',
          activeMenu: '/deliveryManagement/report',
          isHiden: true //默认展示，true为隐藏
        }
      },
      {
        type: 'page',
        path: 'promotion-pay',
        name: 'promotion-pay',
        component: () => import('@/views/DeliveryManagement/PromotionPay/index.vue'),
        meta: {
          title: '付费管理',
          icon: ''
        }
      },
      {
        type: 'page',
        path: 'rechargeTemplate',
        name: 'rechargeTemplate',
        component: () => import('@/views/DeliveryManagement/RechargeTemplate/index.vue'),
        meta: {
          title: '充值模板',
          icon: ''
        }
      }
    ]
  },
  {
    type: 'page',
    path: '/theater',
    name: 'Theater',
    component: Layout,
    meta: {
      title: '短剧管理',
      icon: 'VideoCamera',
      keepAlive: false
    },
    children: [
      {
        type: 'single-page',
        path: '',
        name: 'TheaterList',
        component: () => import('@/views/PlayletManage/v1/Theater.vue'),
        meta: {
          title: '短剧管理',
          icon: ''
        }
      },
      {
        type: 'detail',
        path: 'theaterNewDetail',
        component: () => import('@/views/PlayletManage/v1/TheaterNewDetail.vue'),
        name: 'TheaterNewDetail',
        meta: {
          title: '短剧详情',
          icon: '',
          activeMenu: '/theater',
          isHiden: true //默认展示，true为隐藏
        }
      }
    ]
  },
  {
    type: 'group',
    path: '/member',
    name: 'Member',
    component: Layout,
    meta: {
      title: '会员',
      icon: 'Handbag'
    },
    children: [
      {
        type: 'page',
        path: 'goods',
        name: 'Goods',
        component: () => import('@/views/Member/Goods/Index.vue'),
        meta: {
          title: '商品管理',
          icon: ''
        }
      },
      {
        type: 'page',
        path: 'order',
        name: 'Order',
        component: () => import('@/views/Member/Order/Index.vue'),
        meta: {
          title: '订单管理',
          icon: ''
        }
      }
    ]
  },
  {
    type: 'group',
    path: '/operationsCneter',
    name: 'OperationsCneter',
    redirect: '/operationsCneter/benefit-sign',
    component: Layout,
    meta: {
      title: '运营中心',
      icon: 'Message'
    },
    children: [
      {
        type: 'page',
        path: 'benefit-sign',
        name: 'benefit-sign',
        component: () => import('@/views/OperationsCneter/BenefitSign/Index.vue'),
        meta: {
          title: '福利签到',
          icon: ''
        }
      },
      {
        type: 'page',
        path: 'recommendedBitSkits',
        name: 'RecommendedBitSkits',
        component: () => import('@/views/OperationsCneter/RecommendedBitSkits/Index.vue'),
        meta: {
          title: '推荐位短剧',
          icon: ''
        }
      },
      {
        type: 'page',
        path: 'taskManager',
        name: 'TaskManager',
        component: () => import('@/views/OperationsCneter/TaskManager/Index.vue'),
        meta: {
          title: '任务管理',
          icon: ''
        }
      },
      {
        type: 'page',
        path: 'userSegmentation',
        name: 'UserSegmentation',
        component: () => import('@/views/OperationsCneter/UserSegmentation/Index.vue'),
        meta: {
          title: '用户分层模板',
          icon: ''
        }
      },
      {
        type: 'page',
        path: 'label',
        name: 'Label',
        component: () => import('@/views/OperationsCneter/Label/Index.vue'),
        meta: {
          title: '标签管理',
          icon: ''
        }
      },
      {
        type: 'group',
        path: 'account',
        name: 'Account',
        meta: {
          title: '用户数据',
          keepAlive: true,
          icon: ''
        },
        children: [
          {
            type: 'page',
            path: 'feedback',
            name: 'Feedback',
            component: () => import('@/views/OperationsCneter/Account/Feedback/Index.vue'),
            meta: {
              title: '用户反馈管理',
              icon: ''
            }
          },
          {
            type: 'page',
            path: 'userManageList',
            name: 'UserManageList',
            component: () => import('@/views/OperationsCneter/Account/UserManageList/Index.vue'),
            meta: {
              title: '用户管理模块',
              icon: ''
            }
          },
          {
            type: 'detail',
            path: 'userManageDetail',
            name: 'UserManageDetail',
            component: () => import('@/views/OperationsCneter/Account/UserManageList/UserDetail/Index.vue'),
            meta: {
              title: '用户管理详情',
              icon: '',
              activeMenu: '/operationsCneter/account/userManageList',
              isHiden: true
            }
          },
          {
            type: 'page',
            path: 'complaint',
            name: 'Complaint',
            component: () => import('@/views/OperationsCneter/Account/Complaint/Index.vue'),
            meta: {
              title: '用户举报管理',
              icon: ''
            }
          }
        ]
      },
      {
        type: 'page',
        path: 'publish',
        name: 'Publish',
        component: () => import('@/views/OperationsCneter/Publish/Index.vue'),
        meta: {
          title: '版本管理',
          icon: ''
        }
      },
      {
        type: 'page',
        path: 'rankList',
        name: 'RankList',
        component: () => import('@/views/OperationsCneter/RankList/Index.vue'),
        meta: {
          title: '榜单管理',
          icon: ''
        }
      }
    ]
  },
  {
    type: 'group',
    path: '/business',
    name: 'Business',
    redirect: '/business/adSpace',
    component: Layout,
    meta: {
      title: '商业化',
      icon: 'ShoppingCart'
    },
    children: [
      {
        type: 'page',
        path: 'adSpace',
        name: 'AdSpace',
        component: () => import('@/views/Business/AdSpace/Index.vue'),
        meta: {
          title: '广告位管理',
          icon: ''
        }
      }
    ]
  },
  {
    type: 'group',
    path: '/userRoleManage',
    name: 'UserRoleManage',
    redirect: '/userRoleManage/userList',
    component: Layout,
    meta: {
      title: '用户和角色管理',
      icon: 'UserFilled',
      keepAlive: false
    },
    children: [
      {
        type: 'page',
        path: 'userList',
        component: () => import('@/views/UserRoleManage/User/Index.vue'),
        name: 'UserList',
        meta: {
          title: '用户列表',
          icon: ''
        }
      },
      {
        type: 'page',
        path: 'roleList',
        component: () => import('@/views/UserRoleManage/Role/Index.vue'),
        name: 'roleList',
        meta: {
          title: '角色列表',
          icon: ''
        }
      },
      {
        type: 'page',
        path: 'menuList',
        component: () => import('@/views/UserRoleManage/Menu/Index.vue'),
        name: 'menuList',
        meta: {
          title: '菜单管理',
          icon: ''
        }
      }
    ]
  }
]

// 异步获取菜单
export const asyncRoutes: AppRouteRecordRaw[] = []

const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRoutes as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

// 重置动态路由表
export const resetRouter = (): void => {
  const resetWhiteNameList = ['Redirect', 'Login', '404Page', 'Layout']
  router.getRoutes().forEach(route => {
    const { name } = route
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
